import { Component, Input } from '@angular/core';
import { StatusAccodionEnum } from './model/status-accordion.enum';

@Component({
  selector: 'app-general-timeline-accordion',
  templateUrl: './general-timeline-accordion.component.html',
  styleUrls: ['./general-timeline-accordion.component.scss'],
})
export class GeneralTimelineAccordionComponent {
  @Input() title: string;
  @Input() customClass: string = 'custom-accordion-panel';
  @Input() customClassText: string;
  @Input() accordionOpen = true;
  @Input() ngStyleAccordion;
  @Input() ngStyleAccordionGroup;
  @Input() ngStyleTitle;
  @Input() status: StatusAccodionEnum;

  public statusAccodionEnum = StatusAccodionEnum;

  changeStatus(event) {
    this.accordionOpen = event;
  }
}
